export interface PreferencesPayload {
  so_far_period?: string;
  comparison_forecast_id?: string;
}

export enum PeriodOption {
  THIS_MONTH = 'this_month',
  THIS_QUARTER = 'this_quarter',
  THIS_YEAR = 'this_year'
}

export interface Option {
  name: string;
  value: string;
}
